import AppConstants from "../config/app.constants";

let ImportFileViewService = function ($http, $q) {

    const importFiles = (startDate, endDate, status, fileAdapter, limit, offset) => {
        return $http
            .get(AppConstants.api + `/import-files/get-import-files`, {
                params: {
                    startDate, endDate, status, fileAdapter, limit, offset
                }
            }).then(res => {
                return res.data;
            })
    }

    const evertecBatchFiles = (searchText, status, limit, offset) => {
        return $http
            .get(AppConstants.api + `/import-files/get-evertec-batch-files`, {
                params: {
                    searchText, status, limit, offset
                }
            }).then(res => {
                return res.data;
            })
    }

    const getFileAdapterTypes = () => {
        return $http
            .get(AppConstants.api + `/import-files/get-file-adapter-types`)
            .then(res => {
                return res.data;
            })
    }

    return {
        importFiles, evertecBatchFiles, getFileAdapterTypes
    };
}

ImportFileViewService.$inject = ['$http', '$q'];

export default ImportFileViewService;


// WEBPACK FOOTER //
// ./client/app/services/import-file-view.service.js